function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { createContext, memo, useState, useRef, Children, useMemo, isValidElement, createElement, useContext } from 'react';
/**
 * Log messages in the console with a corresponding urgency
 *
 * @param level The urgency of the message
 * @param message The message to log in the console
 */ var log = function(level, message) {
    if (process.env.NODE_ENV !== "production") {
        var packageName = '[react-use-wizard]';
        switch(level){
            case 'warn':
                console.warn(packageName + " " + message);
                break;
            case 'error':
                console.error(packageName + " " + message);
                break;
            default:
                console.log(packageName + " " + message);
        }
    }
};
var WizardContext = /*#__PURE__*/ createContext(null);
if (process.env.NODE_ENV !== "production") {
    WizardContext.displayName = 'WizardContext';
}
var Wizard = /*#__PURE__*/ memo(function(param) {
    var header = param.header, footer = param.footer, children = param.children, _param_startIndex = param.startIndex, startIndex = _param_startIndex === void 0 ? 0 : _param_startIndex;
    var _useState = _sliced_to_array(useState(startIndex), 2), activeStep = _useState[0], setActiveStep = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isLoading = _useState1[0], setIsLoading = _useState1[1];
    var hasNextStep = useRef(true);
    var hasPreviousStep = useRef(false);
    var nextStepHandler = useRef(function() {});
    var stepCount = Children.count(children);
    hasNextStep.current = activeStep < stepCount - 1;
    hasPreviousStep.current = activeStep > 0;
    var goToNextStep = useRef(function() {
        if (hasNextStep.current) {
            setActiveStep(function(activeStep) {
                return activeStep + 1;
            });
        }
    });
    var goToPreviousStep = useRef(function() {
        if (hasPreviousStep.current) {
            nextStepHandler.current = null;
            setActiveStep(function(activeStep) {
                return activeStep - 1;
            });
        }
    });
    var goToStep = useRef(function(stepIndex) {
        if (stepIndex >= 0 && stepIndex < stepCount) {
            nextStepHandler.current = null;
            setActiveStep(stepIndex);
        } else {
            if (process.env.NODE_ENV !== "production") {
                log('warn', [
                    "Invalid step index [" + stepIndex + "] passed to 'goToStep'. ",
                    "Ensure the given stepIndex is not out of boundaries."
                ].join(''));
            }
        }
    }); // Callback to attach the step handler
    var handleStep = useRef(function(handler) {
        nextStepHandler.current = handler;
    });
    var doNextStep = useRef(/*#__PURE__*/ _async_to_generator(function() {
        var error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(hasNextStep.current && nextStepHandler.current)) return [
                        3,
                        5
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    setIsLoading(true);
                    return [
                        4,
                        nextStepHandler.current()
                    ];
                case 2:
                    _state.sent();
                    setIsLoading(false);
                    nextStepHandler.current = null;
                    goToNextStep.current();
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    setIsLoading(false);
                    throw error;
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    goToNextStep.current();
                    _state.label = 6;
                case 6:
                    return [
                        2
                    ];
            }
        });
    }));
    var wizardValue = useMemo(function() {
        return {
            nextStep: doNextStep.current,
            previousStep: goToPreviousStep.current,
            handleStep: handleStep.current,
            isLoading: isLoading,
            activeStep: activeStep,
            stepCount: stepCount,
            isFirstStep: !hasPreviousStep.current,
            isLastStep: !hasNextStep.current,
            goToStep: goToStep.current
        };
    }, [
        activeStep,
        stepCount,
        isLoading
    ]);
    var activeStepContent = useMemo(function() {
        var reactChildren = Children.toArray(children);
        if (process.env.NODE_ENV !== "production") {
            // No steps passed
            if (reactChildren.length === 0) {
                log('warn', 'Make sure to pass your steps as children in your <Wizard>');
            } // The passed start index is invalid
            if (activeStep > reactChildren.length) {
                log('warn', 'An invalid startIndex is passed to <Wizard>');
            } // Invalid header element
            if (header && !/*#__PURE__*/ isValidElement(header)) {
                log('error', 'Invalid header passed to <Wizard>');
            } // Invalid footer element
            if (footer && !/*#__PURE__*/ isValidElement(footer)) {
                log('error', 'Invalid footer passed to <Wizard>');
            }
        }
        return reactChildren[activeStep];
    }, [
        activeStep,
        children,
        header,
        footer
    ]);
    return /*#__PURE__*/ createElement(WizardContext.Provider, {
        value: wizardValue
    }, header, activeStepContent, footer);
});
var useWizard = function() {
    var context = useContext(WizardContext);
    if (!context && process.env.NODE_ENV !== "production") {
        throw Error('Wrap your step with `Wizard`');
    } else {
        return context;
    }
};
export { Wizard, useWizard }; //# sourceMappingURL=react-use-wizard.esm.js.map
